
import GuestsComponent from './Guests';
import EventTypeComponent from './EventType';
import PlanComponent from './Plan';
import HonoredGuestsComponent from './HonoredGuests';
import SpecialDateComponent from './SpecialDate';
import AddressComponent from './Address';
import FormComponent from './Form';

export const IN_RIGHT_ANIMATION = 'animate__fadeInRight';
export const OUT_LEFT_ANIMATION = 'animate__fadeOutLeft';

export const IN_LEFT_ANIMATION = 'animate__fadeInLeft';
export const OUT_RIGHT_ANIMATION = 'animate__fadeOutRight';

export const DELAY_TIME = 800;

export const LIST_OF_STEPS = [
  {
    key: 'select_event',
    order: 1,
    label: '1. ¿Qué vas a festejar?',
    navHeader: 'Tipo de evento',
    isDone: true,
    component: EventTypeComponent,
    errorMessages: {
      title: 'No podemos crear tu mesa',
      subtitle:
        'Para continuar debes elegir un tipo de evento y así crear tu mesa.',
      type: 'response',
    },
  },
  {
    key: 'select_plan',
    order: 2,
    label: '2. ¿Cómo quieres tu mesa de regalos?',
    navHeader: 'Tipo de plan',
    isDone: false,
    component: PlanComponent,
    errorMessages: {
      title: 'No podemos continuar',
      subtitle:
        'Para continuar debes elegir un tipo de evento y así crear tu mesa.',
    },
  },
  {
    key: 'celebrated',
    order: 3,
    label: '3. Cuéntanos todo sobre tu evento',
    navHeader: 'Datos del evento',
    isDone: false,
    component: FormComponent,
    selfSubmit: true,
    errorMessages: {
      title: 'No podemos continuar',
      subtitle: 'Para continuar debes elegir un número de invitados y aceptar términos y condiciones.',
    },
  }
];



export const LIST_OF_STEPS_NOW =[
  {
    key: 'select_event',
    order: 1,
    label: '1. ¿Qué vas a festejar?',
    navHeader: 'Tipo de evento',
    isDone: true,
    component: EventTypeComponent,
    errorMessages: {
      title: 'No podemos crear tu mesa',
      subtitle:
        'Para continuar debes elegir un tipo de evento y así crear tu mesa.',
      type: 'response',
    },
  },
  {
    key: 'select_plan',
    order: 2,
    label: '2. ¿Cómo quieres tu mesa de regalos?',
    navHeader: 'Tipo de plan',
    isDone: false,
    component: PlanComponent,
    errorMessages: {
      title: 'No podemos continuar',
      subtitle:
        'Para continuar debes elegir un tipo de evento y así crear tu mesa.',
    },
  },
  {
    key: 'address',
    order: 3,
    label: '3. ¿A qué dirección enviaremos tus regalos?',
    navHeader: 'Datos del evento',
    isDone: false,
    selfSubmit: true,
    component: AddressComponent,
  },
  {
    key: 'celebrated',
    order: 4,
    label: '4. Cuéntanos todo sobre tu evento',
    navHeader: 'Datos del evento',
    isDone: false,
    component: FormComponent,
    selfSubmit: true,
    errorMessages: {
      title: 'No podemos continuar',
      subtitle: 'Para continuar debes elegir un número de invitados y aceptar términos y condiciones.',
    },
  }
]

